// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.exRjs9{position:absolute;top:0;left:0;right:0;bottom:0;z-index:150;transition:opacity 0.2s;line-height:normal}.f4Z4IM .OlCByX svg{width:12px;height:12px;font-size:12px;stroke-width:.5}.OmQxRt .OlCByX svg{width:17px;height:17px;font-size:17px;stroke-width:.3}.OmQxRt .OlCByX{top:25px}.OmQxRt .OlCByX.xxJeGS{right:25px}.OmQxRt .OlCByX.gBWg2y{left:25px}.USnryp .OlCByX svg{width:22px;height:22px;font-size:22px;stroke-width:.1}.OlCByX{position:absolute;z-index:180;top:15px;overflow:hidden;cursor:pointer}.OlCByX.xxJeGS{right:15px}.OlCByX.gBWg2y{left:15px}.OlCByX,.OlCByX:focus,.OlCByX:hover{outline:none;border:none;box-shadow:none;background:none}[data-focus-source='script'] [data-playable-hook='player-container'] button.OlCByX:focus{box-shadow:none}.WSRF7j{position:absolute;top:0;left:0;right:0;bottom:0;z-index:170;color:white;background-color:rgba(0,0,0,0.85)}.WSRF7j.wvC7a7{left:50%}.WSRF7j.ctxljR{left:calc(100% - 630px)}@media (max-width: 639px){.exRjs9{width:100%;max-width:480px;left:auto}.exRjs9.TN5H3_{max-width:none}.WSRF7j.wvC7a7,.WSRF7j.ctxljR{left:0}}div[data-vod-player-max-width~="639px"] .exRjs9{width:100%;max-width:480px;left:auto}div[data-vod-player-max-width~="639px"] .exRjs9.TN5H3_{max-width:none}div[data-vod-player-max-width~="639px"] .WSRF7j.wvC7a7,div[data-vod-player-max-width~="639px"] .WSRF7j.ctxljR{left:0}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"info-overlay": `exRjs9`,
	"infoOverlay": `exRjs9`,
	"min-width-250px": `f4Z4IM`,
	"minWidth250Px": `f4Z4IM`,
	"close": `OlCByX`,
	"min-width-500px": `OmQxRt`,
	"minWidth500Px": `OmQxRt`,
	"ltr": `xxJeGS`,
	"rtl": `gBWg2y`,
	"min-width-980px": `USnryp`,
	"minWidth980Px": `USnryp`,
	"content": `WSRF7j`,
	"half": `wvC7a7`,
	"full-screen": `ctxljR`,
	"fullScreen": `ctxljR`,
	"full-width": `TN5H3_`,
	"fullWidth": `TN5H3_`
};
export default ___CSS_LOADER_EXPORT___;
